import React from "react";
import { ReactComponent as TimerIcon } from "../../../assets/images/timer-icon.svg";

import AppSmallButton from "./AppSmallButton";
import Box from "@mui/material/Box";
import { ResendOtpContainer, StyledResendBoxWrap } from "../../Styles/StyledScreens";
import { secondsToHms } from "../../utils/utils";
import { colors } from "@mui/material";
import { theme } from "../../../Customization/Theme";
import { useSelector } from "react-redux";
import { useBotConfigStore } from "../../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { useAppSelector } from "../../../Store";
import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";


interface Props {
  buttonTitle?: string;
  timer?: number;
  resendBtnFn: () => void;
  children?: React.ReactNode;
  [otherProps: string]: any;
}

const AppResendOtp: React.FC<Props> = ({
  buttonTitle = "Resend OTP",
  timer = 10,
  resendBtnFn,
  children,
  ...otherProps
}) => {
  const { isNextNodeAvailable } = useAppSelector(allMessagesStore);
  const { botConfig } = useSelector(useBotConfigStore);
  

  const handleResendBtnClick = () => {
    resendBtnFn();
  };

  return (
    <ResendOtpContainer botConfig={botConfig}>
      {isNextNodeAvailable &&
        <StyledResendBoxWrap className="wrapper">
          {(timer <= 0) ?
            <AppSmallButton
              variant="text"
              onClick={() => handleResendBtnClick()}
            >
              {buttonTitle}
            </AppSmallButton>
            :
            <Box className="timerWrapper">
              <TimerIcon />
              {secondsToHms(timer.toString())}
            </Box>
          }

        </StyledResendBoxWrap>
      }
    </ResendOtpContainer>
  );
};

export default AppResendOtp;
